import { render, staticRenderFns } from "./PersonalDashboard.vue?vue&type=template&id=ef770058&scoped=true&"
import script from "./PersonalDashboard.vue?vue&type=script&lang=js&"
export * from "./PersonalDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PersonalDashboard.vue?vue&type=style&index=0&id=ef770058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef770058",
  null
  
)

export default component.exports